/**
 * Autoplay-when-visible for decorative videos: <div data-ln-autoplay><video preload="none" muted loop playsinline></div>.
 * Nothing downloads until the video is near the viewport; it pauses again when scrolled away.
 * Replaces SG's multi-megabyte GIFs, which all loaded up front.
 */
(() => {
  if (window.lnLazyVideo) return;
  window.lnLazyVideo = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          video.muted = true;
          if (reduceMotion) {
            video.preload = 'metadata';
            return;
          }
          video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  const scan = (root = document) =>
    root.querySelectorAll('[data-ln-autoplay] video:not([data-ln-observed])').forEach((video) => {
      video.dataset.lnObserved = 'true';
      observer.observe(video);
    });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();

  // Theme editor: sections are re-rendered in place.
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
